<script setup>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
const onResize = () => {
  let vW = window.innerWidth
  if (vW <= 1400) vW = 1400
  const size = vW * (1 / 1920)
  document.getElementsByTagName('html')[0].style.cssText = 'font-size:' + size + 'px !important'
}
onResize()
window.addEventListener('resize', onResize, false)
</script>
<template>
  <Header />
  
  <section class="content">
    <router-view v-slot="{ Component }">
      <!-- <transition> -->
        <keep-alive include="Home">
          <component :is="Component" />
        </keep-alive>
      <!-- </transition> -->
    </router-view>
  </section>
  <Footer />
</template>
<style scoped>
::v-global(body){
    /* background: #070A1F; */
    background: #070A1F url('~@/assets/home/bg.png') center center no-repeat;
    /* background-size: 100% auto; */
    background-size: cover;
}
::v-global(#app){
  display: flex;
  flex-direction: column;
}
::v-global(#app>.content){
  flex: 1
}
.content{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
